export default __webpack_public_path__ + "static/media/Security_HeroBanner_Image.932b1d4b.png";